import { render, staticRenderFns } from "./CompetenciaForm.vue?vue&type=template&id=49258c4c"
import script from "./CompetenciaForm.vue?vue&type=script&lang=js"
export * from "./CompetenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports